import { Box, FormControlLabel, Grid, Popover, Stack, Typography } from '@mui/material';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { convertTextToMultiLanguage } from 'common/utils/convert';
import { HexColorPickerDebounce } from 'common/utils/HexColorPickerDebounce';
import { SwitchCustom } from 'components/Common/SwitchCustom';
import { useLayerSelectCardStyle } from 'components/MapView/MapViewStyle';
import { useCheckRTL } from 'hooks/common/useCheckRLF';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';

interface IPolygonLayer {
  id: string;
  index: number;
  label: string;
  visible: boolean;
  color: string;
  typeOfAnalytic: string;
  changeColorAnalyticsLayer: (id: string, color: string, typeOfAnalytic: string, type: string) => void;
  changeVisibleAnalyticsLayer: ActionCreatorWithPayload<string, string>;
  dataPoints?: any[] | null;
  withoutConvertMultiLanguageToggleLabel?: boolean;
}

export const PolygonLayerPaddy = ({
  changeColorAnalyticsLayer,
  changeVisibleAnalyticsLayer,
  typeOfAnalytic,
  id,
  label,
  visible,
  color,
  withoutConvertMultiLanguageToggleLabel = false,
}: IPolygonLayer) => {
  const classes = useLayerSelectCardStyle();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    event.preventDefault();
    event.stopPropagation();
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const { isRTL } = useCheckRTL();

  return (
    <Grid item xs={12} md={12}>
      <FormControlLabel
        labelPlacement={isRTL ? 'start' : 'end'}
        control={<SwitchCustom checked={visible} onClick={() => dispatch(changeVisibleAnalyticsLayer(id))} />}
        label={
          <Stack
            direction={isRTL ? 'row-reverse' : 'row'}
            spacing={1}
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}>
            {color && visible && (
              <Box
                sx={{
                  width: '14px',
                  height: '14px',
                  border: `1px solid ${color}`,
                  borderRadius: '100%',
                  backgroundColor: color,
                }}
                onClick={(e: any) => handleClick(e)}
              />
            )}
            <Typography className={classes.selectText}>
              {withoutConvertMultiLanguageToggleLabel ? label : t(convertTextToMultiLanguage(label, 'mapView'))}
            </Typography>
          </Stack>
        }
      />
      <Popover
        id={'simple-popover'}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        sx={{
          '.MuiPopover-paper': {
            overflowX: 'initial',
            overflowY: 'initial',
          },
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        anchorOrigin={{
          vertical: 160,
          horizontal: 30,
        }}>
        <Box>
          <HexColorPickerDebounce
            color={color}
            onChange={(_color: any) => changeColorAnalyticsLayer(id, _color, typeOfAnalytic, label)}
          />
        </Box>
      </Popover>
    </Grid>
  );
};
